import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BudgetResource, _CompetitionType, _Entailment } from '../../../../core/services/dataBean/EntityCatalog';
import { PrintJson } from '../../../theme/Component/PrintJson';

interface Config {
    date: any;
    budget?: string;
    label?: string;
}

interface Props {
    config: Config;
    idSelector?: number;
    onChange?: (value: number | null) => void;
}

export const SelectBudgetResourceForYear = ({ idSelector, onChange, config }: Props) => {

    const competitionType = useDataBean(_BudgetResource)
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(idSelector);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector)
        }
    }, [idSelector])

    useEffect(() => {
        if (config.date) {
            getLista();
        }
    }, [config.budget])

    const setValue = (e: any) => {
        if (e === "") {
            setID(null);
            onChange(null);
        } else {
            const parsedValue = parseInt(e, 10);
            setID(parsedValue);
            onChange(parsedValue);
        }
    };


    const getLista = () => {

        competitionType.instance.getBudgetResourceForYear(config.date, config.budget ?? null).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);
                    
                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
        {/* <PrintJson json={config}/> */}
            <label>{config.label ?? "Recurso Presupuestal"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value="">...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBudgetResource} >{`${item.DataBeanProperties.Code ?? ""} - ${item.DataBeanProperties.Name ?? ""}`}</option>
                        )
                    })
                }
            </select>
        </>
    )
}